export enum FormAnswerType {
  SelectOne = "Select One",
  SelectMultiple = "Select Multiple",
  YesOrNo = "Yes or No",
  Number = "Number",
  Date = "Date (mm/dd/yyyy)",
  Text = "Text",
  Address = "Address",
}
